import { QUERY_KEYS } from 'api/query-keys';
import { sharedShiftService } from 'api/services';
import { useQuery } from 'react-query';
import { useSiteDetection } from 'shared/hooks';

export const useGetShiftsPartners = (shiftIds: string[]) => {
  const { site } = useSiteDetection();

  const queryFn = async () => await sharedShiftService.getShiftsPartners(site, shiftIds);
  return useQuery(QUERY_KEYS.plannerShiftsPartners(shiftIds), queryFn);
};
